var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFindUserImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1061.435,
    height: 604.673,
    viewBox: "0 0 1061.435 604.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -52.727,
    y1: 1,
    x2: -52.727,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-93.565 -346.243)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49.747,
    cy: 49.747,
    r: 49.747,
    transform: "translate(113.5 376.558)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.37,327.75c0,117.381-69.781,158.366-155.861,158.366s-155.86-40.985-155.86-158.366S318.51,61.042,318.51,61.042,474.37,210.369,474.37,327.75Z",
    transform: "translate(-69.084 285.201)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.208,407.119l1.6-98.237,66.431-121.534L300.055,293.471l.717-44.172,45.784-87.928L300.962,237.61h0l1.29-79.445,49.027-70-48.824,57.509L303.262,0l-5.068,192.845.417-7.956-49.846-76.3,49.047,91.569-4.644,88.726-.138-2.354L235.565,206.24l57.29,88.611-.581,11.1-.1.167.047.911-11.783,225.1h15.743l1.889-116.271,57.149-88.394Z",
    transform: "translate(-54.461 346.243)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.835,
    cy: 3.732,
    rx: 73.835,
    ry: 3.732,
    transform: "translate(852.862 907.449)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.835,
    cy: 3.732,
    rx: 73.835,
    ry: 3.732,
    transform: "translate(585.685 943.451)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.685,
    cy: 8.527,
    rx: 168.685,
    ry: 8.527,
    transform: "translate(288.134 908.47)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.114,
    cy: 18.239,
    rx: 511.114,
    ry: 18.239,
    transform: "translate(132.772 867.832)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 724.332,
    height: 396.038,
    rx: 20.42,
    transform: "translate(281.72 481.131)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,29.5H404.759V406.43H189.735A17.735,17.735,0,0,1,172,388.7Z",
    transform: "translate(110.154 471.172)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.332,227.606v10.066H183V227.606a17.726,17.726,0,0,1,17.735-17.726H889.6a17.726,17.726,0,0,1,17.735,17.726Z",
    transform: "translate(98.72 271.26)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.211,
    cy: 5.211,
    r: 5.211,
    transform: "translate(295.182 490.25)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.211,
    cy: 5.211,
    r: 5.211,
    transform: "translate(308.209 490.25)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.211,
    cy: 5.211,
    r: 5.211,
    transform: "translate(321.237 490.25)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.5,429.38",
    transform: "translate(77.089 242.396)",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5,428.38",
    transform: "translate(78.93 242.528)",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 301.371,
    height: 9.554,
    rx: 1.24,
    transform: "translate(662.993 555.927)",
    fill: "#e02f2f",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.401,
    height: 21.713,
    rx: 1.24,
    transform: "translate(896.62 574.165)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 301.371,
    height: 9.554,
    rx: 1.24,
    transform: "translate(662.993 672.098)",
    fill: "#e02f2f",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.401,
    height: 21.713,
    rx: 1.24,
    transform: "translate(896.62 690.336)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 301.371,
    height: 9.554,
    rx: 1.24,
    transform: "translate(662.993 790.214)",
    fill: "#e02f2f",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.401,
    height: 21.713,
    rx: 1.24,
    transform: "translate(896.62 808.453)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.008,
    cy: 43.008,
    r: 43.008,
    transform: "translate(554.578 649.065)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.2,472.116a1.206,1.206,0,0,1-.182.287,26.936,26.936,0,0,1-1.52,2.249,42.852,42.852,0,0,1-18.89,14.721c-.747.313-1.511.6-2.284.868a15.251,15.251,0,0,1-1.98-1.9,14.86,14.86,0,0,1-3.474-7.2,18.239,18.239,0,0,1-3.474.33,2.328,2.328,0,0,1-.347,0c-8.946-.156-16.623-6.7-20.054-16.05l-.139-.4a32.473,32.473,0,0,1-.677-18.881h0c.043-.208.113-.417.174-.617,2.936-10.083,10.683-17.431,19.9-18.013h1.989c11.673.426,21.07,11.716,21.5,25.838a15,15,0,0,1,6.609,14.7,15.356,15.356,0,0,1,2.849,4.073Z",
    transform: "translate(53.342 242.642)",
    fill: "#192534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.055,472.39a26.941,26.941,0,0,1-1.52,2.249,14.2,14.2,0,0,0-2.319-3.083,16.36,16.36,0,0,0,.156-2.163,14.99,14.99,0,0,0-6.766-12.532c-.478-14.417-10.283-25.934-22.294-25.934-8.581,0-16.024,5.854-19.767,14.452-.1.226-.182.443-.287.677h0c-.313.747-.591,1.5-.868,2.293a31.806,31.806,0,0,1,1.277-4.673l.122-.122c3.344-9.215,10.813-15.755,19.585-16.145h1.989c11.508.695,20.722,11.933,21.165,25.907a14.973,14.973,0,0,1,6.627,14.7A14.816,14.816,0,0,1,582.055,472.39Z",
    transform: "translate(53.302 242.655)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.735,464.121a5.645,5.645,0,0,1-.3,2.605c-.512,1.19-1.737,2.258-1.4,3.474a2.666,2.666,0,0,0,1.876,1.511c3.743,1.268,7.816.512,11.777.686a37.983,37.983,0,0,0,3.969.139,6.323,6.323,0,0,0,3.682-1.285,31.528,31.528,0,0,1-5.793-3.639,6.507,6.507,0,0,1-1.172-1.12,6.87,6.87,0,0,1-1.016-3.978V458.38c-2.831,0-5.654-.043-8.485-.043-.869,0-3.674-.217-4,.764-.156.486.452,1.919.547,2.467a24.546,24.546,0,0,1,.3,2.553Z",
    transform: "translate(52.304 238.591)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.735,464.121a5.645,5.645,0,0,1-.3,2.605c-.512,1.19-1.737,2.258-1.4,3.474a2.666,2.666,0,0,0,1.876,1.511c3.743,1.268,7.816.512,11.777.686a37.983,37.983,0,0,0,3.969.139,6.323,6.323,0,0,0,3.682-1.285,31.528,31.528,0,0,1-5.793-3.639,6.507,6.507,0,0,1-1.172-1.12,6.87,6.87,0,0,1-1.016-3.978V458.38c-2.831,0-5.654-.043-8.485-.043-.869,0-3.674-.217-4,.764-.156.486.452,1.919.547,2.467a24.546,24.546,0,0,1,.3,2.553Z",
    transform: "translate(52.304 238.591)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.979,
    cy: 9.979,
    r: 9.979,
    transform: "translate(585.879 681.504)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.2,483.133a6.614,6.614,0,0,1-.1.868,26.422,26.422,0,0,1-1.416,4.733,22.751,22.751,0,0,1-1.32,3.022c-.373.669-.868,1.285-1.268,1.937l-.573.929a12.669,12.669,0,0,0-.929,1.963,36.854,36.854,0,0,1-5.1.929,42.607,42.607,0,0,1-5.063.3c-9.076,0-18.864-2.354-25.8-7.165,0,0,1.016-.7.868-.868,0-.4-.043-.79-.043-1.19a8.928,8.928,0,0,1,.5-3.022,6.08,6.08,0,0,1,1.5-2.466c.868-.869,2.032-1.407,2.961-2.241a8.788,8.788,0,0,0,2.423-4.212h0c.217-.695.373-1.433.521-2.145a10.421,10.421,0,0,1,.8-2.823,2.511,2.511,0,0,1,.191-.33,3.386,3.386,0,0,1,.469-.617,10.161,10.161,0,0,1,3.057-2.05c.947-.486,2.275-.868,2.936-.061v.061a12.251,12.251,0,0,1,.547,1.529c.53,1.094,2.006,1.233,3.2,1.207a101.6,101.6,0,0,0,12.663-1.06l2.032-.33c1.468-.243,2.493,1.042,3.318,2.293C558.711,475.551,560.518,479.26,560.2,483.133Z",
    transform: "translate(54.586 237.297)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.95,486.18c-.929.208-1.468,1.146-1.9,2a7.721,7.721,0,0,0-1.034,4.638,6.539,6.539,0,0,0,.2,1.885,2.5,2.5,0,0,0,1.094,1.494",
    transform: "translate(53.356 234.927)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.506,
    cy: 11.16,
    rx: 5.506,
    ry: 11.16,
    transform: "translate(586.236 686.887) rotate(-75.66)",
    fill: "#192534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.171,446.477c-5.307-1.355-9.232-4.342-9.554-7.087a2.78,2.78,0,0,0-.521,1.051c-.756,2.944,3.474,6.566,9.441,8.094s11.421.373,12.159-2.605a2.811,2.811,0,0,0,.07-1.008C555.177,447.111,550.374,447.806,545.171,446.477Z",
    transform: "translate(52.432 241.08)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.019,491.425c0,1.511,0,3.014-.1,4.508-.747.313-1.511.6-2.284.868a31.889,31.889,0,0,1-3.474.99,36.861,36.861,0,0,1-5.1.929c-.3-3.6-.99-7.061-.651-10.709h0a17.249,17.249,0,0,1,2.8-7.817,6.678,6.678,0,0,1,2.527-2.441,3.109,3.109,0,0,1,3.326.261,4.759,4.759,0,0,1,1.2,2.215,36.734,36.734,0,0,1,1.407,4.994,4.606,4.606,0,0,0,.087.573A34.416,34.416,0,0,1,565.019,491.425Z",
    transform: "translate(50.024 236.083)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.192,582.237a42.818,42.818,0,0,1-5.211,20.592c-.382.695-.782,1.4-1.233,2.093a1.209,1.209,0,0,1-.182.287,26.922,26.922,0,0,1-1.52,2.249,42.5,42.5,0,0,1-12.289,11.395l-.252.174a44.411,44.411,0,0,1-4.907,2.545c-.469.208-.955.408-1.442.608s-.938.382-1.424.538c-.243.1-.5.191-.756.278h0a.329.329,0,0,0-.087,0c-.53.191-1.077.356-1.615.521l-.408.1c-.486.148-.973.269-1.459.373a36.722,36.722,0,0,1-5.107.929h0a41.924,41.924,0,0,1-5.029.3h-.521a39.17,39.17,0,0,1-6.948-.643l-.417-.07c-.426-.07-.868-.156-1.277-.261h0l-.808-.182a25.433,25.433,0,0,1-2.536-.695,41.131,41.131,0,0,1-4.977-1.85l-.182-.078a42.5,42.5,0,0,1-6.766-3.848,4.634,4.634,0,0,1-.521-.356,43,43,0,1,1,67.96-35.009Z",
    transform: "translate(57.394 227.952)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.909,575.374a9.128,9.128,0,0,1-18.239,0v-.434a9.119,9.119,0,0,1,18.239,0C555.9,575.078,555.909,575.226,555.909,575.374Z",
    transform: "translate(52.082 224.455)",
    fill: "#192534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.909,576.261a9.128,9.128,0,0,1-18.239,0v-.434a14.4,14.4,0,0,1,18.239,0C555.9,575.966,555.909,576.114,555.909,576.261Z",
    transform: "translate(52.082 223.567)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.408,
    cy: 14.408,
    r: 14.408,
    transform: "translate(584.454 796.945)",
    fill: "#192534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.742,573.119a9.128,9.128,0,0,1,7.921-9.041,9.128,9.128,0,1,0,0,18.091A9.128,9.128,0,0,1,537.742,573.119Z",
    transform: "translate(52.392 224.695)",
    fill: "#192534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.708,595.025a9.128,9.128,0,0,1-1.537-11.925,10.044,10.044,0,0,0-.868.869,9.128,9.128,0,1,0,13.688,12.072,9.665,9.665,0,0,0,.738-.955,9.128,9.128,0,0,1-12.02-.061Z",
    transform: "translate(53.896 222.183)",
    fill: "#192534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539,610.3a8.007,8.007,0,0,0-2.154.756c-1.2.868-1.155,2.606-.8,4.021.816,3.231,2.814,6.331,5.871,7.651a14.513,14.513,0,0,0,5.923.868c2.18,0,4.646-.3,6-2.015a7.964,7.964,0,0,0,1.225-3.005,23.869,23.869,0,0,0,1.1-7.99c-1.32.113-2.8.191-3.839-.643s-1.277-2.423-1.737-3.743a.981.981,0,0,0-.339-.538,1.1,1.1,0,0,0-.608-.087,24.57,24.57,0,0,1-4.151-.174c-.868-.113-2.97-1.007-3.613-.252-.469.547-.174,2.215-.539,2.988A4.134,4.134,0,0,1,539,610.3Z",
    transform: "translate(52.324 219.322)",
    fill: "#ffc1c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539,610.3a8.007,8.007,0,0,0-2.154.756c-1.2.868-1.155,2.606-.8,4.021.816,3.231,2.814,6.331,5.871,7.651a14.513,14.513,0,0,0,5.923.868c2.18,0,4.646-.3,6-2.015a7.964,7.964,0,0,0,1.225-3.005,23.869,23.869,0,0,0,1.1-7.99c-1.32.113-2.8.191-3.839-.643s-1.277-2.423-1.737-3.743a.981.981,0,0,0-.339-.538,1.1,1.1,0,0,0-.608-.087,24.57,24.57,0,0,1-4.151-.174c-.868-.113-2.97-1.007-3.613-.252-.469.547-.174,2.215-.539,2.988A4.134,4.134,0,0,1,539,610.3Z",
    transform: "translate(52.324 219.322)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.075,
    cy: 10.075,
    r: 10.075,
    transform: "translate(588.588 808.235)",
    fill: "#ffc1c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567,621.467c-.07.087-.139.191-.217.278l-.426.556a32.672,32.672,0,0,0-5.15,8.555c-.469.208-.955.408-1.442.608s-.938.382-1.424.539c-.243.1-.5.191-.756.278h0a.328.328,0,0,0-.087,0c-.53.191-1.077.356-1.615.521l-.408.1c-.486.148-.973.269-1.459.373a36.751,36.751,0,0,1-5.107.929h0a41.936,41.936,0,0,1-5.029.3h-.521a39.165,39.165,0,0,1-6.948-.643l-.417-.069c-.426-.07-.869-.156-1.277-.261h0l-.808-.182a25.447,25.447,0,0,1-2.536-.695,7.642,7.642,0,0,1,1.867-3.908c-1.954-2.336-5.168-3.257-7.243-5.463a6.976,6.976,0,0,1-.5-.66,2.772,2.772,0,0,1-.269-.53,1.489,1.489,0,0,1-.113-.46,4.017,4.017,0,0,1-.078-.973c-.052-2.467.061-5.281,1.971-6.826a8.989,8.989,0,0,1,3.109-1.39,38.166,38.166,0,0,0,5.645-2.276,4.507,4.507,0,0,1,.33,1.216c.174,1.007.156,2.067.391,3.066a7.4,7.4,0,0,0,3.092,4.343,11.812,11.812,0,0,0,5.089,1.85c1.789.261,3.214-.669,4.9-1.3a5.679,5.679,0,0,0,2.024-1.146,4.664,4.664,0,0,0,1.138-3.17c0-1.146-.13-2.293-.061-3.474a1.662,1.662,0,0,1,.043-.356,1.45,1.45,0,0,1,.99-1.364,1.85,1.85,0,0,1,.947.174l3.248,1.242a22.517,22.517,0,0,1,4.047,1.867A11.23,11.23,0,0,1,567,621.467Z",
    transform: "translate(53.744 218.669)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.43,635.282l-.417-.069c-.426-.069-.869-.156-1.277-.261h0l-.808-.182a25.43,25.43,0,0,1-2.536-.695,41.1,41.1,0,0,1-4.977-1.85,21.5,21.5,0,0,1-.868-8.181,15.077,15.077,0,0,1,.73-3.474c1.824,1.737,4.933.756,7,2.145a4.341,4.341,0,0,1,1.337,1.529,11.543,11.543,0,0,1,1.164,3.552c.13.677.252,1.364.356,2.05v.651c.069.486.13.99.156,1.485A26.345,26.345,0,0,1,536.43,635.282Z",
    transform: "translate(53.687 217.255)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.949,635.095c-.426-.069-.868-.156-1.277-.261h0l-.808-.182a25.451,25.451,0,0,1-2.536-.695,41.13,41.13,0,0,1-4.976-1.85l-.182-.078a22.146,22.146,0,0,1-1.1-9.093,16.246,16.246,0,0,1,.712-3.266c1.824,1.737,4.933.773,7,2.163a4.881,4.881,0,0,1,1.737,2.293,15.215,15.215,0,0,1,.756,2.753c.191,1.016.373,2.032.5,3.066a2.458,2.458,0,0,1,.043.434c0,.1,0,.217,0,.313v.373A29.652,29.652,0,0,1,535.949,635.095Z",
    transform: "translate(53.75 217.374)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.729,629.725a44.4,44.4,0,0,1-4.907,2.545c-.469.208-.955.408-1.442.608s-.938.382-1.424.538c-.243.1-.5.191-.756.278h0a.328.328,0,0,0-.087,0c-.53.191-1.077.356-1.615.521l-.408.1a21.414,21.414,0,0,1,.087-2.354c.061-.617.13-1.233.217-1.85a.911.911,0,0,1,.043-.339.929.929,0,0,0,0-.217c.1-.591.217-1.19.33-1.781a10.883,10.883,0,0,1,1.164-3.552,4.342,4.342,0,0,1,1.346-1.494c2.067-1.39,5.211-.443,6.948-2.145a15.344,15.344,0,0,1,.7,3.109,20.264,20.264,0,0,1-.2,6.036Z",
    transform: "translate(49.134 217.254)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.043,629.428l-.252.174a44.411,44.411,0,0,1-4.907,2.545c-.469.208-.955.408-1.442.608s-.938.382-1.424.538c-.243.1-.5.191-.756.278h0a.328.328,0,0,0-.087,0c-.53.191-1.077.356-1.615.521,0-1.025,0-2.041.087-3.057a3.045,3.045,0,0,1,.069-.79v-.625c.13-.938.287-1.85.478-2.771a15.212,15.212,0,0,1,.755-2.753,4.881,4.881,0,0,1,1.737-2.293c2.067-1.39,5.211-.443,6.948-2.162a14.862,14.862,0,0,1,.73,3.37A20.34,20.34,0,0,1,571.043,629.428Z",
    transform: "translate(49.072 217.378)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.09,
    cy: 8.06,
    rx: 12.09,
    ry: 8.06,
    transform: "translate(586.374 800.775)",
    fill: "#192534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.006,634.961v1.146a.241.241,0,0,0,0,.069h0l-.808-.182a2.666,2.666,0,0,1,0-.46,5.61,5.61,0,0,1,1.937-4.247,1.285,1.285,0,0,1,.269-.217,5.133,5.133,0,0,1,1.563-.869,4.664,4.664,0,0,1,1.633-.313.987.987,0,0,1,.226,0,3.266,3.266,0,0,1,.417,0h-.287a5.533,5.533,0,0,0-3.474,1.737,1.837,1.837,0,0,0-.269.313A5.559,5.559,0,0,0,536.006,634.961Z",
    transform: "translate(52.408 216.031)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.973,635.536a7.034,7.034,0,0,1-.191,1.615,39.17,39.17,0,0,1-6.948-.643l-.417-.07c-.426-.069-.868-.156-1.277-.261h0v-1.216a6.281,6.281,0,0,1,1.146-3.24,1.944,1.944,0,0,1,.269-.33,4,4,0,0,1,1.52-1.164,3.386,3.386,0,0,1,1.459-.33.592.592,0,0,1,.174,0,2.493,2.493,0,0,1,.356,0C543.262,630.272,544.973,632.652,544.973,635.536Z",
    transform: "translate(52.283 216.03)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.488,634.648c-.243.1-.5.191-.756.278h0a5.488,5.488,0,0,0-1.546-3.3l-.261-.261a5.705,5.705,0,0,0-3.109-1.416h-.287a3.138,3.138,0,0,1,.4,0,1.1,1.1,0,0,1,.235,0,5.1,5.1,0,0,1,1.641.313,5.594,5.594,0,0,1,1.19.573,1.016,1.016,0,0,1,.26.191,5.533,5.533,0,0,1,2.232,3.622Z",
    transform: "translate(49.602 216.023)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.187,634.922h0a.328.328,0,0,0-.087,0c-.53.191-1.077.356-1.615.521l-.408.1c-.486.148-.973.269-1.459.373a36.743,36.743,0,0,1-5.107.929h0a6.621,6.621,0,0,1-.13-1.329c0-2.883,1.737-5.263,3.917-5.593a2.261,2.261,0,0,1,.347,0,.543.543,0,0,1,.165,0,3.407,3.407,0,0,1,1.476.33,3.953,3.953,0,0,1,1.164.79,1.673,1.673,0,0,1,.261.243A6.236,6.236,0,0,1,561.187,634.922Z",
    transform: "translate(50.148 216.027)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.871,594.391c-6.479,0-11.768-3.387-12.081-7.651v.4c0,4.455,5.419,8.06,12.1,8.06s12.09-3.6,12.09-8.06v-.4C557.63,591,552.341,594.391,545.871,594.391Z",
    transform: "translate(52.592 221.704)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.17,312.483a42.9,42.9,0,0,0,5.211,20.584c.391.7.79,1.407,1.233,2.093a1.259,1.259,0,0,0,.191.287,25.555,25.555,0,0,0,1.555,2.223,41.225,41.225,0,0,0,6.2,6.853,16.379,16.379,0,0,0,1.355,1.164,38.6,38.6,0,0,0,4.725,3.378l.26.174a46.713,46.713,0,0,0,4.9,2.553l1.45.6c.478.2.929.391,1.424.547.243.1.5.182.756.269h.122q.79.287,1.615.521l.4.1a15.135,15.135,0,0,0,1.468.373c.66.174,1.311.321,1.989.443,1.016.2,2.067.373,3.109.5h0a41.82,41.82,0,0,0,5.029.3h.512a40.008,40.008,0,0,0,6.948-.651,3.212,3.212,0,0,0,.417-.069c.426-.069.868-.156,1.277-.261h0c.278-.052.53-.113.808-.182a24.6,24.6,0,0,0,2.536-.686c.512-.165,1.016-.321,1.52-.5,1.016-.356,2.032-.738,3.005-1.173a3.37,3.37,0,0,0,.443-.182l.191-.087a39.586,39.586,0,0,0,3.752-1.937c1.034-.591,2.041-1.233,3.014-1.911h.061a3.527,3.527,0,0,0,.452-.313,43,43,0,1,0-67.926-35Z",
    transform: "translate(57.408 263.428)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.418,337.865a3.994,3.994,0,0,1,1.259,2.128c-1.251.33-2.527-.287-3.691-.869a47.089,47.089,0,0,0-11.351-3.656,1.738,1.738,0,0,1-.869-.33,1.476,1.476,0,0,1,.052-1.824c.434-.452,1.251-.391,1.841-.417a16.771,16.771,0,0,1,12.758,4.933Z",
    transform: "translate(51.713 255.086)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542,334.033a5.211,5.211,0,0,1-2.875,2.892c-.7.252-1.459.3-2.171.5a2.406,2.406,0,0,0-1.685,1.329,2.845,2.845,0,0,0-.13.938c-.113,3-.2,6.079,1,8.859a19.406,19.406,0,0,0,4.8,6.036c2.189,2.093,4.508,4.212,7.391,5.15a5.543,5.543,0,0,0,5.072-.478,7.529,7.529,0,0,0,1.416-1.642,19.859,19.859,0,0,0,2.432-4.143c1.19-3.057.79-6.479.373-9.736a.781.781,0,0,0-.208-.521.816.816,0,0,0-.608-.1,3.578,3.578,0,0,1-3.622-2.084,5.436,5.436,0,0,1-.2-1.911l.061-3.717a3.152,3.152,0,0,0-.139-1.181,2.97,2.97,0,0,0-1.555-1.346,38.419,38.419,0,0,0-6.323-2.493c-.955-.278-1.685-.747-2.11.278S542.5,332.956,542,334.033Z",
    transform: "translate(52.423 255.461)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542,334.033a5.211,5.211,0,0,1-2.875,2.892c-.7.252-1.459.3-2.171.5a2.406,2.406,0,0,0-1.685,1.329,2.845,2.845,0,0,0-.13.938c-.113,3-.2,6.079,1,8.859a19.406,19.406,0,0,0,4.8,6.036c2.189,2.093,4.508,4.212,7.391,5.15a5.543,5.543,0,0,0,5.072-.478,7.529,7.529,0,0,0,1.416-1.642,19.859,19.859,0,0,0,2.432-4.143c1.19-3.057.79-6.479.373-9.736a.781.781,0,0,0-.208-.521.816.816,0,0,0-.608-.1,3.578,3.578,0,0,1-3.622-2.084,5.436,5.436,0,0,1-.2-1.911l.061-3.717a3.152,3.152,0,0,0-.139-1.181,2.97,2.97,0,0,0-1.555-1.346,38.419,38.419,0,0,0-6.323-2.493c-.955-.278-1.685-.747-2.11.278S542.5,332.956,542,334.033Z",
    transform: "translate(52.423 255.461)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.343,
    cy: 11.343,
    r: 11.343,
    transform: "translate(593.139 569.823)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.211,364.469c1.016.2,2.067.373,3.109.5h0a41.812,41.812,0,0,0,5.029.3h.512a40.01,40.01,0,0,0,6.948-.651,3.213,3.213,0,0,0,.417-.069c.426-.069.869-.156,1.277-.261h0c.278-.052.53-.113.808-.182a24.592,24.592,0,0,0,2.536-.686c.513-.165,1.016-.321,1.52-.5,1.016-.356,2.032-.738,3.005-1.172a21.277,21.277,0,0,1-.617-2.354,25.986,25.986,0,0,1-.33-5.142c0-1.381.061-2.753,0-4.125a10.156,10.156,0,0,0-.478-3.283,4.2,4.2,0,0,0-2.119-2.458,5.843,5.843,0,0,0-4.516-.226,3.1,3.1,0,0,0-.417.269,2.162,2.162,0,0,0-.625.868c-.417,1.042-.868,2.093-1.268,3.135a9.938,9.938,0,0,1-1.016,2.067,5.124,5.124,0,0,1-5.619,1.85,3.329,3.329,0,0,1-.374-.148c-1.737-.7-3.326-2.223-5.141-1.815a3.422,3.422,0,0,0-2.267,1.963.869.869,0,0,0-.061.156,8.817,8.817,0,0,0-.625,2.849,37.991,37.991,0,0,0,.313,9.119Z",
    transform: "translate(52.202 253.651)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.74,352.854a16.379,16.379,0,0,0,1.355,1.164,38.593,38.593,0,0,0,4.725,3.379l.261.174a46.713,46.713,0,0,0,4.9,2.553l1.45.6c.478.2.929.391,1.424.547.243.1.495.182.756.269h.122q.79.287,1.615.521l.4.1c.486.148.981.278,1.468.373.66.174,1.311.321,1.989.443,1.016.2,2.067.373,3.109.5h0a41.814,41.814,0,0,0,5.029.3h.512a40.01,40.01,0,0,0,6.948-.651,3.214,3.214,0,0,0,.417-.069c.426-.069.869-.156,1.277-.261h0c.278-.052.53-.113.808-.182a24.6,24.6,0,0,0,2.536-.686c.512-.165,1.016-.321,1.52-.5,1.016-.356,2.032-.738,3.005-1.172a3.383,3.383,0,0,0,.443-.182l.191-.087a39.587,39.587,0,0,0,3.752-1.937,65.007,65.007,0,0,0,2.171-6.948.866.866,0,0,1,0-.139c-1.355-2.406-2.553-4.907-3.9-7.313a5.584,5.584,0,0,0-4.473-3.37,10.941,10.941,0,0,0-2.909-.538,10.952,10.952,0,0,1-1.667-.287c-1.129-.252-2.38-.5-2.8,0h0a.148.148,0,0,0-.061.113,2.38,2.38,0,0,0,.2,1.737c.191.547.443,1.12.573,1.589a2.383,2.383,0,0,1,.13.695,23.677,23.677,0,0,1-.1,3.048c-.243,1.476-1.06,2.779-1.442,4.212-.174.677-.261,1.381-.373,2.067a22.248,22.248,0,0,1-1.207,4.534,3.1,3.1,0,0,1-.443.868c-.712.869-1.893.538-3.014.373-.816-.695-.773-1.928-.869-2.97a15.631,15.631,0,0,0-1.581-5.02l-.3-.625c-.869-1.8-1.737-3.587-2.553-5.393-1.051-2.241-2.137-4.8-1.268-7.122.252-.695.66-1.311.938-1.98a2.151,2.151,0,0,0,.113-.3,2.893,2.893,0,0,0,.13-.79,1.736,1.736,0,0,0-.4-1.346.694.694,0,0,0-.174-.182.28.28,0,0,0-.1-.069,2.067,2.067,0,0,0-1.893-.087,7.928,7.928,0,0,0-1,.443,47.769,47.769,0,0,0-4.924,3.187,2.467,2.467,0,0,0-1.025,1.19,8.884,8.884,0,0,1-.165.981c-.243.617-.981.8-1.615.938a19.776,19.776,0,0,0-12.611,9.267,10.183,10.183,0,0,0-1.077,2.388A9.92,9.92,0,0,0,513.74,352.854Z",
    transform: "translate(55.229 255.122)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.894,315.985c-1.537,1.572-4,1.633-6.192,1.6l.069-.869-3.083,1.1a8.172,8.172,0,0,0,2.024-2.171,1.381,1.381,0,0,0-1.5-.1,3.126,3.126,0,0,0-1.12,1.112,10.127,10.127,0,0,0-1.12,9.015,2,2,0,0,1-1.989-.13,3.474,3.474,0,0,1-1.277-1.615,1.688,1.688,0,0,0-.808-1.034.868.868,0,0,0-.973.434,1.841,1.841,0,0,0-.208,1.1c.061.869.712,1.737.868,2.606s1.442,1.563.764,2.145a9.913,9.913,0,0,1-2.466.582,1.069,1.069,0,0,1-.712-.7c-.686-1.511-.443-3.274-.868-4.881a11.992,11.992,0,0,0-1.789-3.552,4.963,4.963,0,0,0-.677-.912,2.285,2.285,0,0,1-.66-.756c-.113-.313.1-.773.434-.712a13.565,13.565,0,0,0-1.737-1.424c.608-.764,1.2-1.546,1.737-2.328.2-.278.408-.617.261-.921a.929.929,0,0,0-.347-.339l-1.537-1.042c0-.73,1.45-.46,1.676-1.146a.938.938,0,0,0,0-.556l-.539-1.963,2.05.929a1.389,1.389,0,0,0,.782.182c.538-.078.8-.712.868-1.259a3.579,3.579,0,0,1,.208-1.615h2.779a1.815,1.815,0,0,0-.339-1.311l6.844-.382a9.553,9.553,0,0,1,3.474.243,2.726,2.726,0,0,0,1.155.26.69.69,0,0,0,.677-.79,12.431,12.431,0,0,1,2.788,2.145,2.683,2.683,0,0,0,.79.651.869.869,0,0,0,.964-.113c.191-.2.278-.556.556-.573s.313.139.417.269a6.783,6.783,0,0,1,.947,1.65,5.921,5.921,0,0,0,1.433-.382,1.546,1.546,0,0,0-.26,1.737c.226.582.643,1.077.921,1.633a6.775,6.775,0,0,1,.547,1.893c.139.816.139,1.85-.582,2.249a1.945,1.945,0,0,1-2-.452C558.483,314.318,558.179,314.665,556.894,315.985Z",
    transform: "translate(52.582 258.779)",
    fill: "#192534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.3,356.658a38.6,38.6,0,0,0,4.725,3.379l.261.174a46.706,46.706,0,0,0,4.9,2.553l1.45.6c.478.2.929.391,1.424.547.243.1.5.182.756.269h0c-.3-.868-.5-1.737-.773-2.606a14.714,14.714,0,0,0-3.726-6.132c-1.494-1.494-3.874-3.674-6.079-2.354a6.949,6.949,0,0,0-1.737,1.676,7.771,7.771,0,0,0-1.077,1.589A2.2,2.2,0,0,0,515.3,356.658Z",
    transform: "translate(55.024 252.482)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.85,363.925c1.016-.356,2.032-.738,3.005-1.172a3.384,3.384,0,0,0,.443-.182l.191-.087a39.6,39.6,0,0,0,3.752-1.937c1.033-.591,2.041-1.233,3.014-1.911h.061a18.081,18.081,0,0,1,0-2.909,2.284,2.284,0,0,0-.061-.973,2.317,2.317,0,0,0-.486-.669,4,4,0,0,1-.356-.408c-.981-1.1-1.78-2.293-3.474-2.119a5.213,5.213,0,0,0-3.865,3.257,2.984,2.984,0,0,0-.191.486,33.7,33.7,0,0,0-1.129,4.612c-.226.964-.512,1.893-.721,2.857C562.98,363.126,562.9,363.525,562.85,363.925Z",
    transform: "translate(48.771 252.632)",
    fill: "#e02f2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.372,660.43h0l-.382.208Z",
    transform: "translate(78.471 212.014)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.451,668.105c-10.865.1-25.239-1.685-28.131-3.474-2.206-1.346-3.083-6.166-3.378-8.381H73.62s.608,7.756,3.474,9.554,17.275,3.543,28.131,3.474c3.135,0,4.221-1.138,4.16-2.788C108.977,667.471,107.822,668.088,105.451,668.105Z",
    transform: "translate(113.103 212.564)",
    opacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindUserImg);
export default __webpack_public_path__ + "static/media/FindUserImg.3b9dcc141945ee1c18959e138c2b61cd.svg";
export { ForwardRef as ReactComponent };